import { Alert, IconButton, Snackbar } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "../../hooks/useTranslation";
import { TitleDialog, useClassesSnackBar } from "./CommonSnackbar.style";
import CloseIcon from "@mui/icons-material/Close";
import { AppIconsClose } from "../../../site/components/AppIcons";

type CommonSnackbarProps = {
    open: boolean;
    message: string | JSX.Element;
    messageType: "error" | "success" | "info" | "warning";
    onClose: any;
    buttons?: JSX.Element[] | JSX.Element;
    autoHideDuration?: number | null;
    persistent?: boolean;
    id?: number;
    refSnackBar?: any;
    showTop?: boolean;
};

export const CommonSnackbar = (props: CommonSnackbarProps) => {
    const [open, setOpen] = useState(props.open);
    const [message, setMessage] = useState(props.message);
    //const [isError, setIsError] = useState(props.isError);

    const { t } = useTranslation();

    useEffect(() => {
        setOpen(props.open);
    }, [props.open]);

    useEffect(() => {
        setMessage(props.message);
    }, [props.message]);

    const handleClose = (event: any, reason?: string) => {
        if (reason === "clickaway") {
            return;
        }
        setOpen(false);
        if (props.onClose) props.onClose();
    };

    //const classes = useClassesSnackBar(isError);

    return (
        <Snackbar
            style={{ zIndex: 1111111111 }}
            key={props.messageType}
            ref={props.refSnackBar}
            //sx= {!isError ? classes.root : classes.rootError}
            sx={{ width: "100%" }}
            anchorOrigin={{
                vertical: props.showTop ? "top" : "bottom",
                horizontal: "center",
            }}
            open={open}
            autoHideDuration={
                props.persistent
                    ? null
                    : props.autoHideDuration === undefined
                    ? 6000
                    : props.autoHideDuration
            }
            onClose={handleClose}
            //onExited={handleExited}
        >
            <Alert
                icon={false}
                severity={props.messageType}
                // variant="filled"
            >
                <div className="text-message" style={{ whiteSpace: "pre" }}>
                    <TitleDialog>
                        {t("alert.title." + props.messageType)}
                    </TitleDialog>
                    {message}
                </div>
                <IconButton
                    aria-label="close"
                    color="inherit"
                    sx={{ p: 0.5 }}
                    onClick={handleClose}
                >
                    <AppIconsClose />
                </IconButton>
            </Alert>
        </Snackbar>
    );
};
